import React from 'react';
import { Typography } from '@mui/material';
import MssModal from './MssModal';

function MssDelete({
  onToggle,
  onDelete,
  title,
  resourceName,
  message,
  isLoading,
  id,
  maxWidth = 'xs',
}) {
  const displayMessage =
    message ??
    `Are you sure you want to delete "${resourceName}"? This action will delete and remove the set from your library. This cannot be undone.`;

  return (
    <MssModal
      isOpen
      onClose={onToggle}
      isCloseable
      maxWidth={maxWidth}
      id={id}
      title={title}
      primaryButtonTitle="Yes, Delete"
      onPrimaryClick={onDelete}
      isPrimaryButtonDisabled={isLoading}
      secondaryButtonTitle="No, Cancel"
      onSecondaryClick={onToggle}
    >
      <Typography>{displayMessage}</Typography>
    </MssModal>
  );
}

export default MssDelete;
